import React from "react";

const Footer = () => {
  // Get the current year dynamically
  const currentYear = new Date().getFullYear();

  return (
    <footer className="text-white bg-darkblue py-8 mt-4 border-t border-gray-800">
      <div className="container mx-auto px-5">
        <div 
          className="flex flex-col items-center justify-center text-center space-y-4"
          data-aos="zoom-in" 
          data-aos-duration="1000" 
          data-aos-once="false"
        >
          {/* Personal Intro Line */}
          <p className="text-lg md:text-xl font-light max-w-2xl leading-relaxed">
            I'm <span className="font-bold text-dark-orange">Om Bhaltilak</span> — a 
            Gen AI developer, Artificial Intelligence  and Data Science student. Thanks for checking out my site!
          </p>

          {/* Copyright Line */}
          <div className="text-gray-400 text-sm md:text-md pt-4 border-t border-gray-700 w-full max-w-xs">
            <p>© {currentYear} Om Bhaltilak</p>
          </div>
          
          {/* Credit Line */}
          <p className="text-xs text-gray-500 mt-2">
            {/* Made with ❤️ in Akot */}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;